<template>
  <vf-input v-bind="{ disabled, invalid, variant }" :required>
    <slot>{{ $t.birthDate }}</slot>
    <template #input>
      <base-input
        v-bind="{ disabled, placeholder, required }"
        ref="inputRef"
        v-model="maskedDate"
        :aria-describedby="ariaDescribedby"
        @change="onChange"
      />
    </template>
    <template #end>
      <slot name="end" />
    </template>
  </vf-input>
</template>

<script lang="ts" setup>
/**
 * This component expect the model value to be a string in the format YYYY-MM-DD
 * It will emit the value in the same format, YYYY-MM-DD
 * Locale formats are handled internally and should be specified as a prop when adding EMEA support
 */
const { displayFormat = 'MM/DD/YYYY' } = defineProps<{
  placeholder?: string
  disabled?: boolean
  invalid?: boolean
  variant?: 'inverse'
  displayFormat?: 'MM/DD/YYYY' | 'DD/MM/YYYY'
  required?: boolean
  ariaDescribedby?: string
}>()

const emit = defineEmits<{
  change: [value: string]
}>()

const model = defineModel<string>({ required: true })

const { value: maskedDate, el: inputRef } = useMask('XX/XX/XXXX', {
  regex: /\d/
})

// Temporary solution to emit 'change' event
// 'update:modelValue' should be emitted on 'input' event
const onChange = () => {
  const formatted = dateFormat(maskedDate.value, displayFormat, 'YYYY-MM-DD')

  model.value = formatted
  emit('change', formatted)
}

watch(model, (value) => {
  // the model value should be ALWAYS a string in the format YYYY-MM-DD
  // this watcher will convert the value to the displayFormat
  maskedDate.value = dateFormat(value, 'YYYY-MM-DD', displayFormat)
}, { immediate: true })
</script>
